






































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import FinalConfirmMixins from './mixins';

@Component
export default class FinalConfirmPage extends mixins(Vue, FinalConfirmMixins) {}
